import { useEffect } from "react";
import { stringify } from "worktop/cookie";
import { SHOPIFY_Y, SHOPIFY_S } from "./cart-constants.mjs";
import { getShopifyCookies, buildUUID } from "./cookies-utils.mjs";
const longTermLength = 60 * 60 * 24 * 360 * 1;
const shortTermLength = 60 * 30;
function useShopifyCookies(options) {
  const {
    hasUserConsent = false,
    domain = "",
    checkoutDomain = ""
  } = options || {};
  useEffect(() => {
    const cookies = getShopifyCookies(document.cookie);
    let currentDomain = domain || window.document.location.host;
    if (checkoutDomain) {
      const checkoutDomainParts = checkoutDomain.split(".").reverse();
      const currentDomainParts = currentDomain.split(".").reverse();
      const sameDomainParts = [];
      checkoutDomainParts.forEach((part, index) => {
        if (part === currentDomainParts[index]) {
          sameDomainParts.push(part);
        }
      });
      currentDomain = sameDomainParts.reverse().join(".");
    }
    if (/^localhost/.test(currentDomain))
      currentDomain = "";
    const domainWithLeadingDot = currentDomain ? /^\./.test(currentDomain) ? currentDomain : `.${currentDomain}` : "";
    if (hasUserConsent) {
      setCookie(
        SHOPIFY_Y,
        cookies[SHOPIFY_Y] || buildUUID(),
        longTermLength,
        domainWithLeadingDot
      );
      setCookie(
        SHOPIFY_S,
        cookies[SHOPIFY_S] || buildUUID(),
        shortTermLength,
        domainWithLeadingDot
      );
    } else {
      setCookie(SHOPIFY_Y, "", 0, domainWithLeadingDot);
      setCookie(SHOPIFY_S, "", 0, domainWithLeadingDot);
    }
  }, [options, hasUserConsent, domain, checkoutDomain]);
}
function setCookie(name, value, maxage, domain) {
  document.cookie = stringify(name, value, {
    maxage,
    domain,
    samesite: "Lax",
    path: "/"
  });
}
export {
  useShopifyCookies
};
//# sourceMappingURL=useShopifyCookies.mjs.map
